<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <div v-if="model" class="c-form-item-label-video">
    <!-- isTopLabel el-form的label-position为top时，可设置isTopLabel为true，则c-image组件label为false，只展示视频 -->
    <c-video
      v-bind="$attrs"
      :label="$attrs.isTopLabel ? false : model[prop]?.length ? '查看视频' : '暂无视频'"
      :src="model[prop]"
    />
  </div>
</template>

<script lang="ts">
export default { inheritAttrs: false }
</script>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    model: Record<string, any>
    prop: string
  }>(),
  {}
)
</script>
